import type { PermissionData } from '../types'

export function computeUnlockPermission(permissionData: PermissionData) {
  if (!permissionData.allRoutesLocked) return 'hidden'

  return 'enabled'
}
